export const formatMonthData = (monthIncomes) => {
  let years = []
  let incomeList = []
  monthIncomes.forEach(item => {
    const year = item.month.toString().slice(0, 4)
    years.push(year)
  })
  years = _unique(years)
  incomeList = years.map(year => {
    return {
      year,
      monthList: []
    }
  })
  monthIncomes.forEach(item => {
    years.forEach((year, index) => {
      if (item.month.toString().slice(0, 4) === year) {
        let month = item.month.toString().slice(-2)
        item.monthNum = Number(month)
        incomeList[index].monthList.push(item)
      }
    })
  })
  return incomeList
}

const _unique = (arr) => {
  return Array.from(new Set(arr))
}

// 获取当前年月 202006
export const getCurrentYearMonth = () => {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
	return year + '' + month
}
